module.exports = __webpack_public_path__ + "static/img/Frame1171277103.0f38002f.png";